<template>
  <div class="predicted-transaction-container" :class="{ selected: isSelected && canEditEnvelope }">
    <div @click="canEditEnvelope && toggleActions()">
      <predicted-transaction-row :predicted-transaction="predictedTransaction" :can-edit-envelope="canEditEnvelope"
                                                  :category-name="categoryName" :isSelected="isSelected" />
    </div>
    <actions :actions="actions" :category-name="categoryName" v-if="isSelected && canEditEnvelope" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PredictedTransactionRow from './PredictedTransactionRow.vue';
import Actions from '../../../../../../../../../base-components/Actions.vue';
import Segment from '../../../../../../../../../Segment';
import EditPredictedWithActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedWithActualFlow.vue';
import EditPredictedWOActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedWOActualFlow.vue';
import EditPredictedIncomeWOActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedIncomeWOActualFlow.vue';

import ModalBus from '../../../../../../../../../event-bus/modal-bus';

export default {
  name: 'PredictedTransaction',
  props: [
    'predictedTransaction',
    'canEditCategory',
    'showPrediction',
    'categoryName',
  ],
  components: {
    PredictedTransactionRow,
    Actions,
  },
  computed: {
    ...mapState('cashflowView', ['actionsExpandedFor']),
    hasActual() {
      return this.predictedTransaction.actual;
    },
    isIncome() {
      return this.predictedTransaction.isIncome;
    },
    actions() {
      const icon = this.isIncome ? 'edits-trash' : 'edits-sub-category';
      const onClick = this.openEditPredictedTransaction;
      const text = this.isIncome ? 'מחיקת צפי הכנסה'
        : 'לשנות את סוג ההוצאה';
      return [{ text, icon, onClick }];
    },
    editTransactionPopupToShow() {
      if (this.isIncome) {
        return EditPredictedIncomeWOActualFlow;
      }
      return this.hasActual ? EditPredictedWithActualFlow : EditPredictedWOActualFlow;
    },
    canEditEnvelope() {
      if (this.isIncome) {
        return this.canEditCategory && !this.hasActual;
      }
      return this.canEditCategory;
    },
    isSelected() {
      return this.actionsExpandedFor === this.predictedTransaction.envelopeId;
    },
  },
  methods: {
    ...mapActions('editPredictedTransaction', ['startEditingPredictedTransaction']),
    ...mapActions('cashflowView', ['expandActionsOf']),
    openEditPredictedTransaction() {
      Segment.trackUserInteraction('EditPredictedTransactionClicked', { businessName: this.predictedTransaction.name });
      const popupToOpen = this.editTransactionPopupToShow;
      ModalBus.$emit('open', {
        component: popupToOpen,
        props: {
          predictedTransaction: this.predictedTransaction,
        },
      });
    },
    toggleActions() {
      if (this.isSelected) {
        this.expandActionsOf(null);
      } else {
        this.expandActionsOf(this.predictedTransaction.envelopeId);
      }
    },
  },
};

</script>

<style scoped lang="scss">
    @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .predicted-transaction-container {
    background-color: $riseup_gray_0;
    &.selected {
      background-color: $riseup_v2_light_grey;
    }
    border-bottom: 1px solid $riseup_white;
    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
</style>
